var exports = {
  "container": "x43cbe9c2--915b8c--container",
  "sale": "x43cbe9c2--915b8c--sale",
  "textblock": "x43cbe9c2--915b8c--textblock",
  "rent": "x43cbe9c2--915b8c--rent",
  "host": "x43cbe9c2--915b8c--host",
  "title": "x43cbe9c2--915b8c--title",
  "btn": "x43cbe9c2--915b8c--btn",
  "image": "x43cbe9c2--915b8c--image",
  "town": "x43cbe9c2--915b8c--town",
  "house": "x43cbe9c2--915b8c--house",
  "apart": "x43cbe9c2--915b8c--apart",
  "tablet": "x43cbe9c2--915b8c--tablet",
  "phone": "x43cbe9c2--915b8c--phone",
};

module.exports = exports;
